import React, { useState, useEffect } from 'react';
import {
    Box,
    Grid,
    TextField,
    Button,
    Paper,
    Alert,
} from '@mui/material';
import AuthService from '../Auth/AuthService';
const info = JSON.parse(localStorage.getItem("device")) || null;
const form1 = [
    { label: 'School Name', name: 'schoolName', req: true },
    { label: 'Registration Number', name: 'registrationNumber', req: true },
    { label: 'Dise Code/Number', name: 'diseCode', req: true },
    { label: 'Principal Name', name: 'principalName', req: true },
    { label: 'Board Affiliation', name: 'boardAffiliation', req: true },
    { label: 'Established Year', name: 'establishedYear', req: true },
    { label: 'School Type', name: 'schoolType', req: true },
    { label: 'Medium of Instruction', name: 'mediumOfInstruction', req: true },
    { label: 'Total Students', name: 'totalStudents', type: 'number', req: true },
    { label: 'Total Teachers', name: 'totalTeachers', type: 'number', req: true },
    { label: 'Total Classes', name: 'totalClasses', type: 'number', req: true },
    { label: 'Phone', name: 'contactPhone', req: false },
    { label: 'Address Line 1', name: 'addressLine1', req: true },
    { label: 'Address Line 2', name: 'addressLine2', req: false },
    { label: 'City', name: 'city', req: true },
    { label: 'State', name: 'state', req: true },
    { label: 'Country', name: 'country', req: false },
    { label: 'Postal Code', name: 'pincode', req: true },
    { label: 'Website URL', name: 'websiteUrl', req: false },
];

const addressFields = [
    "addressLine1",
    "addressLine2",
    "city",
    "state",
    "country",
    "pincode",
    "latitude",
    "longitude",
];


const EditSchool = ({ school }) => {
    const [existing, setExisting] = useState({});
    const [message, setMessage] = useState(null);

    useEffect(() => {
        setExisting(school);
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (addressFields.includes(name)) {
            setExisting((prev) => ({
                ...prev,
                addressDTO: {
                    ...prev.addressDTO,
                    [name]: value,
                },
            }));
        } else {
            setExisting((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };
    const handleSetAddress = async () => {
        const info = JSON.parse(localStorage.getItem("device"));

        if (!info) {
            setMessage({
                type: 'error',
                text: "This app requires access to your location. Please enable location permission to proceed."
            });
            return false;
        }

        existing.addressDTO.latitude = info.latitude;
        existing.addressDTO.longitude = info.longitude;


        return true;
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateFormSection(form1)) return;
        handleSetAddress();
        console.log('Updated school:', existing);
        try {
            const url = AuthService.pathUrl("UPDATE", "/schools/" + school?.id);
            await AuthService.putAuth(url, existing);
            window.location.reload();
        } catch (error) {
            console.error("Error fetching schools:", error);
        }
        alert('School information updated successfully!');
    };

    const validateFormSection = (formFields) => {
        for (let field of formFields) {
            if (field.req) {
                const name = field.name;
                let value;
                if (addressFields.includes(name))
                    value = existing.addressDTO?.[name];
                else
                    value = existing[name];

                if (value === undefined || value === null || value.toString().trim() === "") {
                    alert(`Please fill out the "${field.label}" field.`);
                    return false;
                }
            }
        }
        return true;
    };

    return (
        <Paper elevation={3} sx={{ p: 4, maxWidth: '100%', mt: 0, boxShadow: 'none' }}>

            <form onSubmit={handleSubmit}>
                <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    {form1.map(({ label, name, type = 'text', req = true }) => (
                        <Grid item xs={12} sm={6} key={name}>
                            <TextField
                                fullWidth
                                required={req}
                                label={label}
                                name={name}
                                type={type}
                                value={
                                    addressFields.includes(name)
                                        ? existing.addressDTO?.[name] || ""
                                        : existing[name] || ""
                                }
                                onChange={handleChange}
                            />

                        </Grid>
                    ))}
                </Grid>
                <Box display="flex" justifyContent="flex-end" mt={4}>
                    <Button
                        variant="contained"
                        fullWidth
                        type="submit"
                        sx={{
                            px: 4,
                            py: 1,
                            borderRadius: 6,
                            backgroundColor: '#1b1914',
                            '&:hover': {
                                backgroundColor: '#332a14ff',
                            },
                        }}
                    >
                        Update
                    </Button>
                </Box>
            </form>
            {/* Alerts */}
            {
                message && (
                    <Alert
                        severity={message.type === "error" ? "error" : "success"}
                        sx={{ mb: 3, borderRadius: 2 }}
                    >
                        {message.text}
                    </Alert>
                )
            }
        </Paper>
    );
};

export default EditSchool;
